import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { defer, from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Patient } from '../models/patient.model';
import { Provider } from '../models/provider.model';
import { ProviderCustomizeService } from './provider-customize.service';
import { SharedDataService } from './shared-data.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderBrandingResolver  {
  constructor(
    private providerCustomizeService: ProviderCustomizeService,
    private sharedDataService: SharedDataService,
    private userService: UserService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> {
    return defer(() => {
      const { token, call } = route.queryParams;

      this.sharedDataService.setToken(token);
      this.sharedDataService.setCall(call);

      if (!environment.production && route.queryParams['api-url']) {
        this.sharedDataService.apiUrl = route.queryParams['api-url'];
      }

      this.providerCustomizeService.beginProviderResolution();
      return this.getPatientProvider$().pipe(
        map((provider) => {
          this.providerCustomizeService.resolveProvider(provider);
        }),
        catchError(() => this.clearBranding())
      );
    });
  }

  private getPatientProvider$(): Observable<Provider> {
    const currentUser = this.sharedDataService.getCurrentUser() as Patient | null;
    if (currentUser?.provider) {
      return of(currentUser.provider);
    }

    return from(this.userService.getMe<Patient>())
      .pipe(map((currentPatient) => {
        this.sharedDataService.setCurrentUser(currentPatient);
        return currentPatient.provider;
      }));
  }

  private clearBranding(): Observable<void> {
    this.providerCustomizeService.clear();
    return of(void 0);
  }
}
